import type { SessionView } from 'eve/events'

import { activeTurn, calls, openInteractions } from 'eve/events'

export type DocueAgentLegalResearchPhase = 'researching' | 'waiting' | 'preparing'

const PHASE_PRIORITY: Record<DocueAgentLegalResearchPhase, number> = {
  preparing: 0,
  researching: 1,
  waiting: 2,
}

export interface DocueAgentLegalResearchStatus {
  id: string
  phase: DocueAgentLegalResearchPhase
  startedAt?: number
}

/** Read resolved call ownership and relayed questions from eve's native view. */
export function docueAgentLegalResearchState(view: SessionView) {
  const turnId = activeTurn(view)?.turnId
  const statusesById = new Map<string, DocueAgentLegalResearchStatus>()
  for (const call of calls(view, { kind: 'agent', name: 'finnish-law' })) {
    if (!turnId || call.turnId !== turnId || !call.taskId || call.state === 'cancelled' || call.state === 'rejected')
      continue

    const settled = call.state === 'completed' || call.state === 'failed'
    const phase = settled
      ? 'preparing'
      : openInteractions(view, { about: { callId: call.callId } }).length ? 'waiting' : 'researching'
    const previous = statusesById.get(call.taskId)
    const timestamp = Date.parse(call.startedAt ?? '')
    const startedAt = Number.isFinite(timestamp) ? timestamp : undefined
    statusesById.set(call.taskId, {
      id: call.taskId,
      phase: previous && PHASE_PRIORITY[previous.phase] > PHASE_PRIORITY[phase] ? previous.phase : phase,
      startedAt: previous?.startedAt === undefined
        ? startedAt
        : startedAt === undefined ? previous.startedAt : Math.min(previous.startedAt, startedAt),
    })
  }
  const statuses = [...statusesById.values()]
  return {
    status: statuses.find(status => status.phase !== 'preparing') ?? statuses.at(-1),
    statuses,
  }
}
